import { Box, Typography } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

interface Props {
  updatedAt: Date;
}

const FooterContainer = styled(Box)`
  text-align: center;
  @media print {
    display: none;
  }
`;

export const Footer = ({ updatedAt }: Props) => {
  return (
    <FooterContainer id={"presentation-footer"} py={3} px={4} mt={3}>
      {!!updatedAt && (
        <Typography m={2} data-testid="presentation-last-updated">
          Last updated on {new Date(updatedAt).toLocaleDateString("en-US")}
        </Typography>
      )}
      <Typography variant="body2" mt={2}>
        Disclaimer: The information contained herein has been obtained through
        sources deemed reliable but cannot be guaranteed as to its accuracy. Any
        information of special interest, including but not limited to, lot size
        or interior square feet, should be obtained through independent
        verification.
      </Typography>
    </FooterContainer>
  );
};
